<template>
    <div>
        <img class="icon_img" style="height:100px" src="../../../static/images/icon/NEEWER_Control-app-icon-optimized-9b9ab116-d204-4754-b3ac-fc8876f57c6a.png"/>
        <div class="app_desc" >功能描述：neewer control center windows安装包上传页面，提供给neewer support center供客户下载</div>
        <div class="app_desc" >neewer 用户使用下载页面地址：<a target="_blank" href="https://support.neewer.com/neewer_control_center_detail?menu=1">点击打开</a></div>
        <div class="app_desc" >注意：上传包的名称即为下载安装包名称，请勿中文命名</div>
        <div class="app_desc">当前版本安装包下载路径：{{ packageUrl }}</div>
        <div class="app_desc">上次更新时间：{{ updateTime }}</div>
        <div class="app_desc"><p>点击下图上传更新</p></div>
        <div class="app_desc">
            <a-upload
                name="avatar"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                :action="uploadOss"
                :before-upload="beforeUpload"
                @change="handleChange"
            >
                <div>
                <a-icon :type="loading ? 'loading' : 'plus'" />
                <div class="ant-upload-text">
                    {{ process }}
                </div>
                </div>
            </a-upload>
        </div>
    </div>
</template>
  
  <script>
  import { tips,confirm } from "@/utils/util";
  import { multipartUpload } from "@/utils/Oss";
  import { getNccDownloadUrl,updateNccDownloadUrl } from "@/api/index";
  import { formatToStr } from "@/utils/dateUtils";
  export default {
    components: {

    },
    name: "ncc-version",
    created() {
      this.getConfigUrl();
    },
    data() {
        return {
            packageUrl: "",
            loading: false,
            imageUrl: '',
            process: "点击上传",
            updateTime: ""
        }
    },
    methods: {
    handleChange(info) {
      if (info.file.status === 'uploading') {
       
        return;
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
      }
    },
    async getConfigUrl(){
      const ret = await getNccDownloadUrl();
      this.packageUrl = ret?.resultData?.content;
      this.updateTime = formatToStr(ret?.resultData?.updateTime,"YYYY-MM-DD HH:mm:ss");
    },

    async uploadOss(file){
        const payload = {
            okBack: async () => {
                this.loading = true;
                let res = await multipartUpload(file.name,file,null,"neewer_support/ncc",this.monitorUploadProcess);
                
                let data = {
                  content: res.url
                };
                updateNccDownloadUrl(data).then(res =>{
                  this.getConfigUrl();
                  this.loading = false;
                });
            },
            title: `是否上传该版本:${file.name},确认后会直接上传到官网`
      };
      confirm(this, payload);
    },
    monitorUploadProcess(p){
        this.process = Math.ceil(p * 100,4) + "%";
    },
    beforeUpload(file) {
      if(file.name.indexOf(".exe") < 0){
        tips(this,false,"请上传正确的windows安装包")
        return false;
      }
      return true;
    },
    }
  };
  </script>
  
  <style lang="less" scoped>
    .icon_img{
        margin-left: 40px;
        height:80px;
    }

    .app_desc{
        font-size: 16px;
        color: black;
        margin-left: 40px;
        margin-top:20px;
    }

    .avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
  </style>
  